import { createFileRoute } from "@tanstack/react-router";
import { User } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/workspace/$workspaceSlug/contacts")({
  component: ContactsPage,
});

function ContactsPage() {
  const { t } = useTranslation();

  return (
    <div className="flex h-full flex-col gap-4 p-4">
      <div className="max-w-4xl mx-auto w-full">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <div className="flex items-center gap-3 mb-8">
            <User className="h-8 w-8 text-blue-600" />
            <h1 className="text-3xl font-bold text-gray-900">{t("pages:contacts.title")}</h1>
          </div>

          <div className="space-y-6">
            <div>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">
                {t("pages:contacts.subtitle")}
              </h2>
              <p className="text-gray-600 leading-relaxed">{t("pages:contacts.description")}</p>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mt-8">
              <div className="p-6 bg-blue-50 rounded-lg">
                <h3 className="font-semibold text-blue-900 mb-2">
                  {t("pages:contacts.features.contactDirectory.title")}
                </h3>
                <p className="text-blue-800 text-sm">
                  {t("pages:contacts.features.contactDirectory.description")}
                </p>
              </div>

              <div className="p-6 bg-green-50 rounded-lg">
                <h3 className="font-semibold text-green-900 mb-2">
                  {t("pages:contacts.features.interactionHistory.title")}
                </h3>
                <p className="text-green-800 text-sm">
                  {t("pages:contacts.features.interactionHistory.description")}
                </p>
              </div>

              <div className="p-6 bg-purple-50 rounded-lg">
                <h3 className="font-semibold text-purple-900 mb-2">
                  {t("pages:contacts.features.contactGroups.title")}
                </h3>
                <p className="text-purple-800 text-sm">
                  {t("pages:contacts.features.contactGroups.description")}
                </p>
              </div>

              <div className="p-6 bg-orange-50 rounded-lg">
                <h3 className="font-semibold text-orange-900 mb-2">
                  {t("pages:contacts.features.insights.title")}
                </h3>
                <p className="text-orange-800 text-sm">
                  {t("pages:contacts.features.insights.description")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
